export default "__VITE_ASSET__CvfA90E0__"